import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FieldMediaTile, FieldMediaPreview } from "@/components/TaskFiles";
import { ChevronDown, ChevronRight, Camera } from "lucide-react";

const fmtD = (s) => { if (!s) return "—"; const d = new Date(s); return isNaN(d) ? String(s) : d.toLocaleDateString("en-GB"); };

function JobGroup({ g, onOpen, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border border-slate-100 rounded-xl" data-testid={`inst-media-group-${g.job_ref}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-3 py-2 text-left cursor-pointer" data-testid={`inst-media-toggle-${g.job_ref}`}>
        {open ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
        <Link to={`/tasks/${g.job_ref}`} onClick={(e) => e.stopPropagation()} className="text-sm font-semibold text-indigo-600 hover:underline">Job {g.job_ref}</Link>
        <span className="text-xs text-slate-500 truncate">{g.job_title}</span>
        <span className="ml-auto text-xs text-slate-500 whitespace-nowrap">Installed {fmtD(g.installation_date)} · {g.items.length} file{g.items.length === 1 ? "" : "s"}</span>
      </button>
      {open && (
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-6 gap-2 px-3 pb-3">
          {g.items.map((it) => <FieldMediaTile key={it.id} item={it} onOpen={onOpen} />)}
        </div>
      )}
    </div>
  );
}

export function CustomerInstallationMedia({ customerId }) {
  const [d, setD] = useState(null);
  const [preview, setPreview] = useState(null);
  useEffect(() => { api.get(`/customers/${customerId}/installation-media`).then((r) => setD(r.data)).catch(() => setD({ groups: [], total: 0 })); }, [customerId]);
  if (!d) return null;
  return (
    <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="user-installation-media">
      <h2 className="text-sm font-bold text-slate-900 mb-3 flex items-center gap-2"><Camera className="w-4 h-4 text-slate-400" />Installation Media <span className="text-xs font-normal text-slate-400" data-testid="inst-media-total">{d.total}</span></h2>
      {!d.groups.length && <p className="text-sm text-slate-400" data-testid="inst-media-empty">No installation photos or videos yet.</p>}
      <div className="space-y-2">{d.groups.map((g, i) => <JobGroup key={g.job_ref} g={g} onOpen={setPreview} defaultOpen={i === 0} />)}</div>
      {preview && <FieldMediaPreview item={preview} onClose={() => setPreview(null)} />}
    </section>
  );
}
